import { CombinedLogo } from "@components/CombinedLogo";
import { useCustomer } from "@contexts/CustomerContext";
import { Badge, Box, Stack, Text } from "@repo/ui/core";
import { IconCalendar } from "@repo/ui/icons";
import { motion } from "framer-motion";

export function TitleSlide() {
  const customer = useCustomer();

  return (
    <Box ta="center" w="100%" maw={1400}>
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
      >
        <Box style={{ display: "flex", justifyContent: "center" }}>
          <CombinedLogo size="xl" />
        </Box>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.3 }}
      >
        <Stack align="center" gap="lg" mt={60}>
          <Text
            size="clamp(1.25rem, 2.5vw, 1.75rem)"
            fw={500}
            lh={1.3}
            style={{
              background:
                "linear-gradient(135deg, var(--customer-accent-light) 0%, var(--customer-secondary) 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            Infrastructure for the Next Generation of Automotive Software
          </Text>

          <Box
            h={3}
            w={120}
            style={{
              background:
                "linear-gradient(90deg, transparent, var(--customer-accent), transparent)",
              borderRadius: 2,
            }}
          />

          <Badge
            size="lg"
            variant="light"
            leftSection={<IconCalendar size={14} />}
            style={{
              backgroundColor:
                "color-mix(in srgb, var(--customer-accent) 12%, transparent)",
              color: "var(--customer-accent-light)",
            }}
          >
            {customer.onsiteDates}
          </Badge>
        </Stack>
      </motion.div>
    </Box>
  );
}
